export const handleErrorLogging = (error: Error) => {
  // Future use for error logging on third party tool (e.g. Sentry - https://docs.sentry.io/platforms/javascript/)
  console.error(error);
};
